import React, { useEffect, useState } from 'react' // eslint-disable-line
import styled from 'styled-components'
import { useBasketTotalCount } from '@sentecacommerce-theme/lib'
import { useSpring, animated } from 'react-spring'

export const AnimatedBasketCount = () => {
  const [animate, setAnimate] = useState(false)

  const itemsInBasketCount = useBasketTotalCount()

  useEffect(() => {
    setAnimate(true)

    const animateTimeout = setTimeout(() => {
      setAnimate(false)
    }, 400)

    return () => clearTimeout(animateTimeout)
  }, [itemsInBasketCount])

  const style = useSpring({
    transform: animate ? 'scale(1.2)' : 'scale(1)',
  })

  return (
    <>
      {itemsInBasketCount ? (
        <Count>
          <animated.span style={style}>{itemsInBasketCount}</animated.span>
        </Count>
      ) : (
        <></>
      )}
    </>
  )
}

const Count = styled.span.attrs({
  className: 'd-block',
})`
  & > span {
    position: absolute;
    font-size: 1.1rem;
    font-weight: bold;
    right: -1rem;
    top: -0.8rem;
    width: 2rem;
    height: 2rem;
    line-height: 2rem;
    border-radius: 50%;
    background-color: ${({ theme }) => theme.palette.burntSienna};
    color: ${({ theme }) => theme.palette.secondary};
    text-align: center;
  }
`
